import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import RadixThemeProvider from './lib/RadixThemeProvider.jsx'
import './lib/i18n'
import { I18nProvider } from './lib/I18nProvider.jsx'
import { ThemeProvider } from './context/ThemeContext.jsx'
import { CurrencyProvider } from './context/CurrencyContext.jsx'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { initializeTheme } from './utils/themeColors.js'

// Initialize theme from localStorage or system preference (before React renders)
initializeTheme();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <RadixThemeProvider>
        <I18nProvider>
          <CurrencyProvider>
            <BrowserRouter>
              <App />
              <ToastContainer 
                position="top-right" 
                theme="colored"
                autoClose={3000} 
                newestOnTop 
                pauseOnHover 
              />
            </BrowserRouter>
          </CurrencyProvider>
        </I18nProvider>
      </RadixThemeProvider>
    </ThemeProvider>
  </StrictMode>,
)
